import { DriverFieldsType } from 'QuoteApp/services/endpoints/GetDetails/types';
import { DriverDataByFieldValueTypeRecordValue } from 'QuoteApp/utils/formik';

import { sanitizeBoolString, sanitizeString } from '../utils';

export const transformMilitaryService = (
  driver: DriverFieldsType,
  driverEditability: DriverDataByFieldValueTypeRecordValue<boolean>
) => {
  // only update if editable
  if (driverEditability.militaryServiceType) {
    return {
      serviceType: sanitizeString(
        driver.militaryServiceType,
        driverEditability.militaryServiceType
      ),
      militaryRank: sanitizeString(
        driver.militaryRank,
        driverEditability.militaryRank
      ),
      isDeployed: sanitizeBoolString(
        driver.isDeployed,
        driverEditability.isDeployed
      ),
    };
  } else {
    return undefined;
  }
};
